import { ParsedUrlQuery } from "querystring";

export function getPathSegments(query: ParsedUrlQuery): string[] {
  const queryPath = query.path;

  if (!queryPath) {
    throw new Error(
      `Expected context.query.path to have valid value, but it was '${queryPath}'`,
    );
  }

  return Array.isArray(queryPath) ? queryPath : [queryPath];
}
